export default __webpack_public_path__ + "static/media/0fa17012252f2f2c.e0497270e909577d1e5ea832074e5844.svg";